import { render, staticRenderFns } from "./AddKNF.vue?vue&type=template&id=3f28e088&scoped=true"
import script from "./AddKNF.vue?vue&type=script&lang=js"
export * from "./AddKNF.vue?vue&type=script&lang=js"
import style0 from "./AddKNF.vue?vue&type=style&index=0&id=3f28e088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f28e088",
  null
  
)

export default component.exports